<!-- OLD CALENDAR STORE
<div class="card">
  <div class="ui-g-12">
    <div class="ui-g-12">
      <h2>{{ 'common.storeCalendars' | translate }}</h2>
      <button [pTooltip]="addCalendarTitle" pButton class="k-generic-btn" type="button" icon="fa fa-plus" iconPos="center" style="float: right; margin-left: 10px;" (click)="openAddCalendarGroupDialog();"></button>
    </div>
  </div>
  <div class="ui-g-12 ui-g-nopad form-group">
    <div class="ui-g ui-g-12">

      <div class="ui-g ui-fluid">
        <p-panel class="ui-g-12" *ngFor="let calendarGroupStore of calendarGroupStoreList; let i=index">
          <p-header>
            <div class="ui-helper-clearfix">
              <span class="ui-panel-title">#{{ i }}</span>
              <button pTooltip="Delete Item" pButton type="button" (click)="deleteCalendarGroupStore(calendarGroupStore)" icon="fa fa-times"
                      iconPos="center" class="ui-button-danger btnDelete slim" style="width: 32px; float: right"></button>
            </div>
          </p-header>
          <div class="ui-g-12  ui-fluid">
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ 'calendarGroupList.code' | translate }}</span><br>
              <strong>{{ calendarGroupStore.calendarGroupCode }}</strong>
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ 'calendarGroupList.description' | translate }}</span><br>
              <strong>{{ calendarGroupStore.calendarGroupDescription }}</strong>
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ 'calendarGroupList.start_date' | translate }}</span><br>
              <strong>{{ calendarGroupStore.startDate | date:'dd/MM/yyyy' }}</strong>
            </div>
          </div>
          <p-footer class="clearfix">&nbsp;</p-footer>
        </p-panel>
      </div>
    </div>
  </div>
</div> -->


<div class="card">
  <div class="ui-g-12">
    
    <app-kontable 
      title="{{ 'common.storeCalendars' | translate }}"
      [source]="calendarGroupStoreList"
      [columns]="['calendarGroupCode', 'calendarGroupDescription', 'startDate']"
      [titles]="['common.storeCode', 'common.description', 'common.date_start']" 
      [showGlobalFilter]="false"
      [showRecoverButton]="false"
      [showAddButton]="true"
      [showEditButton]="false"
      [showInfoButton]="false"
      [showDetailsButton]="false"
      [showTotalPages]="false"
      [showTotalRecord]="false"
      [defaultRowsPerPageOptions]="null"
      (onAdd)="openAddCalendarGroupDialog()"
      (onRemove)="deleteCalendarGroupStore($event)">
    </app-kontable>

  </div>
</div>


<p-dialog [header]="addCalendarTitle" [(visible)]="addDialog" [modal]="true" [draggable]="false" [resizable]="false" [width]="500">
  <form *ngIf="fields && form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" >
    <div class="ui-dialog-content Loyalty">
      <div class="ui-g-12 ui-md-12">
        <span class="label" [ngClass]="{'required': !fields.calendar_group_id.nullable}">{{ fields.calendar_group_id.keyName }}</span>
        <p-dropdown [options]="calendarGroupList" formControlName="calendar_group_id" [style]="{'width':'100%'}" [filter]="true" #itemSelected></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.calendar_group_id"></app-validation-msg>
      </div>
      <div class="ui-g-12 ui-md-12">
        <span class="label" [ngClass]="{'required': !fields.start_date.nullable}">{{ fields.start_date.keyName }}</span>
        <p-calendar dateFormat="dd/mm/yy" formControlName="start_date" showIcon="true" #dateStart></p-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.start_date"></app-validation-msg>
      </div>
    </div>

    <div class="ui-dialog-footer" style="display: flex; justify-content: center;">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-plus"
              iconPos="left" label="{{ 'common.add' | translate }}" (click)="addCalendarGroupStore(itemSelected, dateStart);"></button>
    </div>
  </form>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-calendars/store-common-calendars.component.html